import Vue from 'vue'
import moment from 'moment'
import store from '@/store/index'
import u from '@/utils'
import axios from 'axios'
import Promise from 'bluebird'

const state = {
  loadingSelfServices: false,
  selfServices: [],
  intents: [],
  selfServiceMetrics: [],
  chatBotLoader: false,
  selfServiceProfiles: {}
}

const getters = {
  getChatBotLoader(state) {
    return state.chatBotLoader
  }
}

const mutations = {
  setSelfServicesLoadingState(state, isLoading) {
    state.loadingSelfServices = isLoading
  },
  setSelfServices(state, selfServices) {
    state.selfServices = selfServices
  },
  updateSelfService(state, selfService) {
    let index = state.selfServices.findIndex(
      item => item.hexId === selfService.hexId
    )
    state.selfServices.splice(index, 1, selfService)
  },
  setSelfServiceMetrics(state, selfServiceMetrics) {
    state.selfServiceMetrics = selfServiceMetrics
  },
  setIntents(state, intents) {
    state.intents = intents
  },
  setChatBotLoader(state, loaderState) {
    state.chatBotLoader = loaderState
  },
  setSelfServiceProfiles(state, payload) {
    state.selfServiceProfiles = {
      ...state.selfServiceProfiles,
      [payload.selfService.hexId]: payload.profiles
    }
  }
}

const actions = {
  async fetchSelfServices({ commit }) {
    commit('setSelfServicesLoadingState', true)
    let response = await axios.get('/api/v1/selfServices')
    let selfServices = [...response.data._embedded.selfServices]
    selfServices = selfServices.map(selfService => {
      selfService.intent = []
      return u.processResp(selfService)
    })
    commit('setSelfServices', selfServices)
    commit('setSelfServicesLoadingState', false)
    return selfServices
  },

  async fetchSelfServiceProfiles({ commit }, selfService) {
    let response = await axios.get(
      `/api/v1/selfServices/${selfService.hexId}/profiles`
    )
    let profiles = [...response.data._embedded.profiles]
    profiles = profiles.map(profile => u.processResp(profile))
    commit('setSelfServiceProfiles', { selfService, profiles })
    return profiles
  },

  async addProfilesToSelfService(context, payload) {
    let data = payload.profileIds
      .map(profileId => {
        return `/api/v1/profiles/${profileId}`
      })
      .join('\n')
    let response = await axios.put(
      `/api/v1/selfServices/${payload.selfService.hexId}/profiles`,
      data,
      {
        headers: {
          'Content-Type': 'text/uri-list'
        }
      }
    )
    return response.data
  },

  async fetchIntents({ commit }) {
    let response = await axios.get('/api/v1/intents')
    let intents = [...response.data._embedded.intents]
    intents = intents.map(intent => u.processResp(intent))
    commit('setIntents', intents)
    return intents
  },

  async fetchSelfServiceMetrics({ commit }) {
    let response = await axios.get('/api/v1/selfServices/metrics')
    let selfServiceMetrics = response.data
    commit('setSelfServiceMetrics', selfServiceMetrics)
    return selfServiceMetrics
  },

  raiseAutomationRequest(context, selfServiceTriggerModel) {
    let postBody = {
      variables: selfServiceTriggerModel.variables,
      businessReason: selfServiceTriggerModel.businessReason
    }
    return axios.post(
      `/api/v1/selfServices/${selfServiceTriggerModel.serviceId}/raise`,
      postBody
    )
  },

  async updateSelfService({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/selfServices/${hexId}`, body)
    response.data.intent = []
    response.data = u.processResp(response.data)
    commit('updateSelfService', response.data)
    return response.data
  },

  saveSelfService(context, selfServiceData) {
    let postBody = {
      name: selfServiceData.name,
      description: selfServiceData.description,
      documentation: selfServiceData.documentation,
      bot: selfServiceData.bot
        ? `/api/v1/bots/${selfServiceData.bot.hexId}`
        : null,
      workflow: selfServiceData.workflow
        ? `/api/v1/workflows/${selfServiceData.workflow.hexId}`
        : null,
      profiles: selfServiceData.profiles
        ? selfServiceData.profiles.map(profile => {
            return `/api/v1/profiles/${profile.hexId}`
          })
        : null,
      proposals: selfServiceData.proposals,
      automationRequests: []
    }
    if (selfServiceData.hexId) {
      return axios.patch(
        `/api/v1/selfServices/${selfServiceData.hexId}`,
        postBody
      )
    } else {
      return axios.post('/api/v1/selfServices', postBody)
    }
  },

  async gotoSource({ commit }, service) {
    let response = await axios.get(
      `/api/v1/selfServices/${service.hexId}/source`
    )
    return response
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
